import AdminAndManagerPageGuard from './AdminAndManagerPageGuard';

export default AdminAndManagerPageGuard;
